import { sendRequestProtocols } from "../axios";

export default {
  state: {
    podriadsData: [],
    podriadslastID: "",
    podriadsDataTotal: 0,
  },
  mutations: {
    SET_PODRIADS_TOTAL(state, commit) {
      state.podriadsDataTotal = commit;
    },
    SET_PODRIADS_LAST_ID(state, commit) {
      state.podriadslastID = commit;
    },
    SET_PODRIADS_DATA(state, commit) {
      state.podriadsData = commit;
    },
  },
  actions: {
    getPodriadData({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequestProtocols("showtabledriad", "post", data).then(
          (response) => {
            commit("SET_PODRIADS_DATA", response.data.podriads.data);
            commit("SET_PODRIADS_LAST_ID", response.data.lastID);
            commit("SET_PODRIADS_TOTAL", response.data.total);
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
  },
  getters: {
    getPodriadsData: (state) => state.podriadsData,
    getPodriadsLastID: (state) => state.podriadslastID,
    getPodriadsDataTotal: (state) => state.podriadsDataTotal,
  },
};
